import { MutationCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

import { ERROR } from '@/utils/constants';
import { capitalizeFirstLetter } from '@/lib/utils';

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      let message = ERROR.GENERIC;

      if (mutation.meta?.errorMessage) {
        message = mutation.meta.errorMessage;
      } else if (error instanceof AxiosError && error.response?.data?.context) {
        message = error.response.data.context[0];
      } else if (error instanceof Error && error.message) {
        message = error.message;
      }

      toast.error(capitalizeFirstLetter(message));
    },
    onSuccess: (_data, _variables, _context, mutation) => {
      queryClient.invalidateQueries();

      if (mutation.meta?.successMessage) {
        toast.success(mutation.meta.successMessage);
      }
    },
  }),
});
